import React from 'react';
import { differentiators } from '../data/content';
export function Differentiators() {
  return <section className="bg-navy px-3 py-4 sm:px-6" data-id="element-30" data-mp="1mcov2wbletnh">
      <div className="mx-auto max-w-2xl text-center" data-id="element-31" data-mp="1mb3xsyxw8wlx">
        <h2 className="font-display text-[1.35rem] font-extrabold uppercase leading-none text-white sm:text-[1.85rem]" data-id="element-32" data-mp="1r3ndc1g561td">
          THIS ISN'T JUST ANOTHER POOL &amp; SPA REPAIR EBOOK
        </h2>
        <p className="mt-1 font-display text-[0.82rem] font-extrabold uppercase text-sun sm:text-[1rem]" data-id="element-33" data-mp="zdiva9futqvb">
          IT'S A READY-TO-USE DIAGNOSTIC SYSTEM.
        </p>
        <div className="mt-2 grid gap-1.5 text-left sm:grid-cols-2" data-id="element-34" data-mp="18dfazlk9nfe8">
          {differentiators.map((item, i) => {
          const isLastOdd = i === differentiators.length - 1 && differentiators.length % 2 === 1;
          return <div key={item.title} className={`rounded-md border border-navy-line bg-navy-soft px-2.5 py-2 ${isLastOdd ? 'sm:col-span-2' : ''}`} data-id="element-35" data-mp="2jrj5csurn5jt" data-mpi={i}>
                <h3 className="font-display text-[0.8rem] font-extrabold text-aqua sm:text-[0.92rem]" data-id="element-36" data-mp="bp3tvahx2k4p">
                  <span aria-hidden="true" data-id="element-37" data-mp="7oaa8tbibrhm">{item.emoji}</span> {item.title}
                </h3>
                <p className="mt-0.5 text-[0.76rem] leading-[1.35] text-white/80 sm:text-[0.86rem]" data-id="element-38" data-mp="2n30iopt0i8b">{item.body}</p>
              </div>;
        })}
        </div>
        <p className="mt-2 font-display text-[0.78rem] font-extrabold uppercase text-white sm:text-[0.92rem]" data-id="element-39" data-mp="3ov3zrrel3k52">
          Less guessing. Fewer unnecessary checks.{' '}
          <span className="text-aqua" data-id="element-40" data-mp="3k2j8awj5hj4p">More structured pool &amp; spa diagnostics.</span>
        </p>
      </div>
    </section>;
}